module.exports = __webpack_public_path__ + "img/subir_archivo_gris.b4527270.svg";